<!--
 Preview Container Computer
 Component show results and suggestions for a search result in table style for computer only.
 devs@droxit.de
 Copyright (c) 2021 droxIT GmbH
-->
<template>
<b-container fluid="md">
    <!-- Result and Suggestions -->
      <table class="table-bordered" style="width: 100%">
        <thead>
          <b-tr>
            <b-th class="header-cell suggest-header">
              <b-row class="rocketsearch-column-header">
                <b-col id="rocketsearch-suggest-header-text">
                  <p class="rocketsearch-column-header-text">
                    {{ $t('suggests') }}
                  </p>
                </b-col>
              </b-row>
            </b-th>

            <b-th class="header-cell">
              <b-row class="rocketsearch-column-header">
                <b-col >
                  <p class="rocketsearch-column-header-text">
                    {{$t('search_results')}}
                  </p>
                  <p v-if="results.total_hits > 0" class="rocketsearch-column-show-all">
                    <span class="rocketsearch-text-show-all" v-on:click="$emit('showAll')" style="font-weight: lighter">
                        {{ $t('show_all_results') }}
                    </span>
                  </p>
                </b-col>
              </b-row>
            </b-th>
          </b-tr>
        </thead>

        <!-- Result and Suggestions -->
        <b-tr>
          <b-td md="4" id="rocketsearch-suggest-column" class="content-cell">
            <SuggestList :suggests=suggests />
            <FacetsContainerComputer :facets=results.facets :filters=filters />
          </b-td>
          <b-td md="8" id="rocketsearch-result-column" class="content-cell">
            <ResultList :results=results :showAllResults="false" :isMobile="false" />
          </b-td>
        </b-tr>
        <!-- Footer -->
        <b-tr id="rocketsearch-footer">
          <b-td id="rocketsearch-powered" >
            <a href="https://rocketsearch.eu/" target="_blank">
              <span id="rocketsearch-grey-text">powered by </span>
              <span id="rocketsearch-green-text">rocket </span>
              <span id="rocketsearch-blue-text"> search</span>
            </a>
          </b-td>
        </b-tr>
      </table>
    </b-container>
</template>

<script>
import ResultList from "./ResultList";
import SuggestList from "./SuggestList";
import FacetsContainerComputer from "./ShopComponents/FacetsContainerComputer";

export default {
  name: "PreviewContainerComputer",
  props: {
    suggests: Array,
    results: Object,
    facets: Object,
    filters: Object,
  },
  components: {
    ResultList,
    SuggestList,
    FacetsContainerComputer
  }
}
</script>